import React, { Fragment, useEffect, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import TicketCard from "../../components/tickets/ticket-card/TicketCard.jsx";
import Pagination from "../../components/common/pagination/Pagination.jsx";

const TicketList = () => {
  const [tickets, setTickets] = useState([]);
  const [pagination, setPagination] = useState();

  const getMyTickets = async (params) => {
    const path = "tickets";
    try {
      const response = await getApi({ path, params: { ...params, limit: 20 } });
      setPagination(response?.data);
      setTickets(response?.data?.docs);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getMyTickets({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getMyTickets(allFilter);
  };

  return (
    <Fragment>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.5,
          // ease: [0, 0.71, 0.2, 1.01]
        }}
        className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
      >
        <div className="w-full flex items-center justify-between">
          <h3 className="text-gray-800 dark:text-white text-lg">
            لیست پیام ها
          </h3>
          <Link
            to={"/ticket"}
            className="mt-1 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            ارسال پیام جدید
          </Link>
        </div>
        <div className="mt-6 flex flex-col">
          {tickets?.length ? (
            tickets?.map((item) => {
              return <TicketCard key={item?._id} data={item} />;
            })
          ) : (
            <p className="w-full py-6 flex justify-center items-center text-gray-800 dark:text-white">
              هیچ پیام ثبت شده ای وجود ندارد.
            </p>
          )}
        </div>
        <div className="mt-6">
          <Pagination
            pagination={pagination}
            filterDataHandler={filterDataHandler}
          />
        </div>
      </motion.div>
    </Fragment>
  );
};

export default TicketList;
